import { render, staticRenderFns } from "./classOpenServiceTwo1.vue?vue&type=template&id=f5ac51fe&scoped=true&"
import script from "./classOpenServiceTwo1.vue?vue&type=script&lang=ts&"
export * from "./classOpenServiceTwo1.vue?vue&type=script&lang=ts&"
import style0 from "./classOpenServiceTwo1.vue?vue&type=style&index=0&id=f5ac51fe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5ac51fe",
  null
  
)

export default component.exports